import { render } from "./ai-checkbox.vue?vue&type=template&id=684921e8"
import script from "./ai-checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-checkbox.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ai-checkbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "684921e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('684921e8', __exports__)) {
    api.reload('684921e8', __exports__)
  }
  
  module.hot.accept("./ai-checkbox.vue?vue&type=template&id=684921e8", () => {
    api.rerender('684921e8', render)
  })

}


export default __exports__